/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
import { FontSizes, FontWeights, getTheme, Icon, Link, Panel, PrimaryButton } from "@fluentui/react";
import React from "react";
import { buttonStyles } from "./Module";
import { ShowNavigation2 } from "./ShowNavigation2";
import { ShowTeamsHelp } from "./ShowTeamshelp";
import { ShowPreview } from "./ShowPreview";
import { ShowMeta } from "./ShowMeta";
import { ShowPreviewEmails } from "./ShowYourPreviewEmails";


const theme = getTheme();

export const FirstTime = (): JSX.Element => {
    const [isOpen, setOpen] = React.useState(false);
    const [option, setOption] = React.useState(0);
    const onRenderFooterContent = () => (
        <div>
            <PrimaryButton onClick={() => { setOpen(false) }} styles={buttonStyles}>
                Close
            </PrimaryButton>

        </div>
    );

    return <div style={{ paddingTop: 50 }}>
        <div style={{ textAlign: 'center', paddingBottom: 50 }}> </div>
        <div>
            <div>  <Icon iconName={'Cloud'} styles={{ root: { fontSize: FontSizes.medium, fontWeight: FontWeights.semibold, color: theme.palette.red, paddingLeft: 10 } }} />
                <Link onClick={() => {
                    setOption(1);
                    setOpen(true);
                }} styles={{ root: { paddingLeft: 10 } }}>Navigate and save your emails.</Link></div>
            <div> Use the Buttons to navigate to your documents inside OneDrive, Teams or Sharepoint</div>
        </div>
        <div style={{ paddingTop: 20 }}>
            <div>  <Icon iconName={'People'} styles={{ root: { fontSize: FontSizes.medium, fontWeight: FontWeights.semibold, color: theme.palette.red, paddingLeft: 10 } }} /> <Link
                onClick={() => {
                    setOption(2);
                    setOpen(true);
                }}
                styles={{ root: { paddingLeft: 10 } }}>Send to specific Teams Tags or Teams Users </Link></div>
            <div> Send your emails to specific Teams tags or users.</div>
        </div>
        <div style={{ paddingTop: 20 }}>
            <div>  <Icon iconName={'GroupedList'} styles={{ root: { fontSize: FontSizes.medium, fontWeight: FontWeights.semibold, color: theme.palette.red, paddingLeft: 10 } }} /> <Link styles={{ root: { paddingLeft: 10 } }} onClick={() => {
                setOption(3);
                setOpen(true);
            }}>Change your metadata </Link></div>
            <div>For each selected location you can update metadata accordingly </div>
        </div>
        <div style={{ paddingTop: 20 }}>
            <div>  <Icon iconName={'Link12'} styles={{ root: { fontSize: FontSizes.medium, fontWeight: FontWeights.semibold, color: theme.palette.red, paddingLeft: 10 } }} />
                <Link styles={{ root: { paddingLeft: 10 } }} onClick={() => {
                    setOption(4);
                    setOpen(true);
                }}>Preview documents or create shareble links</Link></div>
            <div>Find your documents inside your document libraries preview documents or create a shareble link</div>
        </div>
        <div style={{ paddingTop: 20 }}>
            <div>  <Icon iconName={'MailAlert'} styles={{ root: { fontSize: FontSizes.medium, fontWeight: FontWeights.semibold, color: theme.palette.red, paddingLeft: 10 } }} /> <Link styles={{ root: { paddingLeft: 10 } }}
                onClick={() => {
                    setOption(5);
                    setOpen(true);
                }}
            >Find previous emails</Link></div>
            <div>Quickly find previous emails from the selected mail (sender)</div>
        </div>
        <Panel
            isOpen={isOpen}
            onDismiss={() => { setOpen(false) }}
            headerText="Help"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={onRenderFooterContent}
            // Stretch panel content to fill the available height so the footer is positioned
            // at the bottom of the page
            isFooterAtBottom={true}
        >
            {option == 1 && <ShowNavigation2 />}
            {option == 2 && <ShowTeamsHelp />}
            {option == 3 && <ShowMeta />}
            {option == 4 && <ShowPreview />}
            {option == 5 && <ShowPreviewEmails />}

        </Panel>
    </div>;
};
